import { Paper } from '@mantine/core';
import { FC } from 'react';

import OrderPointsTable from '../../components/tables/order-points-table';

export const OrderPointsPage: FC = () => {
  return (
    <Paper h="100%" p={0} withBorder>
      <OrderPointsTable />
    </Paper>
  );
};
